<template>
    <div>
        <div class="pro-setting">
            <Loading v-if="is_all_loading || is_loading" />
            <div class="head">
                <div class="left">
                    <i @click="onlyClose"><svg-icon name="close" /></i>
                    {{ get_data.application_title }}
                </div>
                <div class="right">
                    <div class="desc">Updated 2 min ago</div>
                    <el-button class="pre-btn" text  @click="onlyView">Preview</el-button>
                    <el-button class="settings-btn"  type="plain" @click="is_right_panel_open = !is_right_panel_open">Settings</el-button>
                    <el-button  plain @click="saveCallInside()" :disabled="!is_can_save">Save</el-button>
                    <!-- <el-button class="del-btn"  type="danger" @click="is_show_del_modal = true" v-if="application_status === 'draft'">Delete</el-button> -->
                    <el-button  plain @click="publish()" :disabled="!(application_status === 'draft' || application_status === 'closed' || has_unpublished_changes === 1 || is_can_save || (!call_api_btn.publish && call_api_btn.is_change))">{{ application_status === 'closed' ? 'Republish' : 'Publish' }}</el-button>
                </div>
            </div>

            <!-- edit setting saveing put in ProgramForm  -->
            <div :class="['pro-setting-box', is_right_panel_open && 'pro-setting-box--with-panel']" v-if="!is_all_loading && !is_loading">

                <div class="left-template">
                    <ProgramForm ref="formLeft" :data="data" :type="type" :is_edit_setting="type==='create' || type==='edit'"
                        :only_view="is_only_for_view" :porgram_for_who="porgram_for_who" :is_copy="is_copy" :key_refrash_left="key_refrash_left" :key_refrash_left_country="key_refrash_left_country"
                        @close_only_view="closeOnlyForView" @update-data="updateLeft" @save-form="saveAllSetting" :is_first_create="is_first_create" @handle_old_data="handleOldData" :is_can_save ="is_can_save"/>
                </div>
                <Transition name="slide-right" v-show="!is_only_for_view">
                    <div class="right-template" v-show="is_right_panel_open">
                        <FormFormRight 
                            ref="formRight"
                            :data="data" :type="type" @update-data="updateRight"
                            :is_show_all="true"
                            :ambassador_application_id="porgram_id"
                            :ambassador_application_name="data.basic[0].question[0].client_view.val"
                            :application_status="application_status"
                            :is_edit="type === 'edit'"
                            :title="data.settings[0].section_groups[0].group_setting[0].input_value"
                            :key="key_refrash_right"
                            @toggle-panel="is_right_panel_open = false" 
                            @invite-time-error="handleInviteTimeError"
                            @update-account-type="accountTypeUpdated"/>
                    </div>
                </Transition>
            </div>
        </div>

        <el-dialog v-model="is_show_alert_modal" class="alert-modal" :show-close="false" width="330" @close="is_click_window=false">
            <div class="box">
                <header class="delete-header">Save changes?</header>
                <p>Any unsaved changes will be permanently removed.</p>
                <div class="btns">
                    <el-button @click="is_click_window=false;openClose()" text>Discard</el-button>
                    <el-button type="primary" @click="saveCallInside(); will_close_setting=true">Save & exit</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog v-model="is_show_save_modal" class="alert-modal" :show-close="false" width="330">
            <div class="box">
                <header class="delete-header">{{ type === 'create' ? 'Create' : 'Update' }} application?</header>
                <p>Changes to your settings will be reflected with future applicants and will not affect any prior applicants.</p>
                <div class="btns">
                    <el-button @click="is_show_save_modal=false">No</el-button>
                    <el-button type="primary" @click="saveCallInside();is_show_save_modal=false">Confirm</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog v-model="is_show_del_modal" class="alert-modal" :show-close="false" width="330">
            <div class="box">
                <header class="delete-header">Delete application?</header>
                <div class="btns">
                    <el-button @click="is_show_del_modal = false">Don't delete</el-button>
                    <el-button class="modal-del-btn" type="danger" @click="delPro()">Delete</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog v-model="is_show_unp_modal" class="un-pub-modal" :show-close="false" width="330">
            <div class="box">
                <header class="delete-header">Submission error</header>
                <div>Please review and complete the required field(s): <br />
                    <ul>
                        <li v-for="(v,k) in err_box" :key="k">{{ v }}</li>
                    </ul>
                </div>
                <div class="btns">
                    <el-button type="primary" @click="is_show_unp_modal = false">OK</el-button>
                </div>
            </div>
        </el-dialog>

        <ApplicationPublishModal :url="url_link" ref="pub_modal" />

        <el-dialog v-model="is_show_publish_modal" class="publish-checklist-modal" :show-close="false" width="480">
            <div class="box">
                <header>Are you ready to publish?</header>
                <p class="sub">Review your settings before your application goes live. <span class="link" @click="is_show_publish_modal = false; is_right_panel_open = true">View settings.</span></p>
                <div class="checklist" v-if="type === 'create' || application_status === 'draft'">
                    <label class="checklist-item" v-for="(item, i) in [
                        { title: 'Personalize application', desc: 'You can customize the external title, headers, provide a summary, and add custom questions.' },
                        { title: 'Set default creator account type', desc: 'Choose a default creator account type: storefront or shortlink – or \'No Default\' if you want to decide at the time of approval.' },
                        { title: 'Add social authentication fields', desc: 'Ask applicants to connect their Instagram and/or TikTok. You can require they authenticate one or both.' },
                        { title: 'Configure automations', desc: 'You can send automated emails and auto-reject applications based on certain criteria.' },
                        { title: 'Customize email templates', desc: 'Be sure to customize automated emails before publishing. You can code them in basic HTML or send a simple email with personalization fields.' },
                    ]" :key="i" @click="publish_checklist[i] = !publish_checklist[i]">
                        <Checkbox :checked="publish_checklist[i]" @click.native.stop="publish_checklist[i] = !publish_checklist[i]" />
                        <div class="checklist-text">
                            <span class="checklist-title">{{ item.title }}<span class="red">*</span></span>
                            <span class="checklist-desc">{{ item.desc }}</span>
                        </div>
                    </label>
                </div>
                <div class="btns">
                    <el-button @click="is_show_publish_modal = false">Cancel</el-button>
                    <el-button type="primary" :disabled="!publish_all_checked &&( application_status === 'draft' || type === 'create')" @click="is_show_publish_modal = false; doPublish()">Confirm</el-button>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute, onBeforeRouteLeave } from 'vue-router';
import { ElButton, ElDialog } from 'element-plus';
import ProgramForm from '@/components/programs/Form/ProgramForm.vue';
import FormFormRight from '@/components/programs/Form/FormFormRight.vue';
import Loading from '@/components/ui/Loading.vue';
import ApplicationPublishModal from '@/components/programs/ApplicationPublishModal.vue';
import { FormSetting as DefaultFormData, getIndex, getFormApiData, HandleErrFunction, checkBasic, checkSocial } from '@/utils/ProgramsData.js';
import Checkbox from '@/components/ui/Checkbox.vue';

const store = useStore();
const router = useRouter();
const route = useRoute();
const { proxy } = getCurrentInstance();

// ─── template refs ────────────────────────────────────────────────
const formLeft = ref(null);
const pub_modal = ref(null);

// ─── state ────────────────────────────────────────────────────────
const is_loading             = ref(false);
const type                   = ref('create');
const is_copy                = ref(false);
const get_form_data_api      = ref('');
const data_old               = ref(DefaultFormData);   // 存取改動前的資料
const data                   = ref(DefaultFormData);
const porgram_for_who        = ref(1);
const porgram_id             = ref(null);
const application_status     = ref('draft');           // 預設草稿
const call_api_btn           = reactive({ publish: false, is_change: false });
const has_unpublished_changes = ref(0);                // 後端回傳：只存檔未發布 = 1
const is_click_publish       = ref(false);
const get_data               = reactive({ application_title: '', application_url: '', create_tag: '', application_type: 'flexible' });
const is_all_loading         = ref(true);
const is_show_alert_modal    = ref(false);
const from_list_handle_for_view = ref(false);
const is_only_for_view       = ref(false);
const key_refrash_left       = ref(0);
const key_refrash_left_country = ref(0);
const key_refrash_right      = ref(0);
const will_close_setting     = ref(false);
const is_save_call_in        = ref(false);
const is_first_create        = ref(false);
const is_show_del_modal      = ref(false);
const is_show_save_modal     = ref(false);
const is_show_unp_modal      = ref(false);
const is_show_publish_modal  = ref(false);
const publish_checklist      = ref([false, false, false, false, false]);
const publish_all_checked    = computed(() => publish_checklist.value.every(Boolean));
const err_box                = ref([]);
const get_old_data           = reactive({ old: null, new: null });
const is_click_window        = ref(false);
const is_saving              = ref(false);             // 回上一頁只能手動關閉的紀錄
const resolveLeave           = ref(null);
const pendingNavigation      = ref(null);
const originalURL            = ref(null);
const is_leave               = ref(false);             // 重整用，避免往上一頁跳彈窗
const is_key_ref             = ref(false);             // 鍵盤重整紀錄
const is_right_panel_open    = ref(true);
const is_time_err            = ref(false);
const formRight              = ref(null);
// ─── computed ─────────────────────────────────────────────────────
const url_link = computed(() => {
    const url = !store.state.user_data
        ? ''
        : store.state.user_data.merchant_account.anchor_ambassador_subdomain
            || `${store.state.user_data.merchant_account.merchant_display_name}.anchor.store`;
    const baUrl = data.value.settings && data.value.settings[0]
        ? data.value.settings[0].section_groups[0].group_setting[1].input_value
        : '';
    return `${url}/p/${baUrl}`;
});

const is_can_save = computed(() => {
    return type.value === 'create' || !(
        JSON.stringify(data.value) === JSON.stringify(data_old.value) &&
        JSON.stringify(get_old_data.old) === JSON.stringify(get_old_data.new)
    );
});

const permission_recruitment = computed(() =>
    store.state.user_data?.permission_list?.recruitment
);

const is_link_only = computed(()=> {
    return store.state.user_data?.merchant_account?.platform_type === 'linkonly';
});
// ─── methods ──────────────────────────────────────────────────────
const handleInviteTimeError=(msg) => {
    is_time_err.value = msg
};

// 儲存與更新
const handleOldData = (val) => {
    if (val.tip === 'old') { // 只有 getData() 初次進入才有 old
        get_old_data.old = JSON.parse(JSON.stringify(val.block));
        get_old_data.new = JSON.parse(JSON.stringify(val.block));
        data_old.value   = JSON.parse(JSON.stringify(val.handle_data));
        data.value       = JSON.parse(JSON.stringify(val.handle_data));
    } else {
        get_old_data.new = JSON.parse(JSON.stringify(val.block));
        data_old.value   = JSON.parse(JSON.stringify(val.handle_data));
        const block_open = val.block.find(item => item.field === 'social_account')?.is_add;
        checkSocial(val.handle_data.social_account, data.value.settings, block_open);
    }
}

// 儲存完會重新 CALL 一次
const getData = async () => {
    is_loading.value = true;
    const field = type.value === 'create' ? 'application_template_id' : 'ambassador_application_id';
    const id    = type.value === 'create' ? porgram_for_who.value : porgram_id.value;
    const api   = `${get_form_data_api.value}?${field}=${id}`;

    try {
        const res = await proxy.$ajax(api, { method: 'get' });
        console.log('res.data.data-->', res.data.data);
        data.value = getFormApiData(res.data.data, { data: data.value, $store: store });
        has_unpublished_changes.value = res.data.data.has_unpublished_changes;

        if (type.value === 'create') {
            const tit_index = getIndex(data.value.basic, 'title', 'application_title');
            console.log('data.value',data.value)
            data.value.basic[tit_index.i].question[tit_index.ii].client_view.val = get_data.application_title;
            data.value.settings[0].section_groups[0].group_setting[0].input_value = get_data.application_title;
            data.value.settings[0].section_groups[0].group_setting[1].input_value = get_data.application_url;
            data.value.settings[0].section_groups[0].group_setting[2].input_value = get_data.create_tag;
            data.value.application_type = get_data.application_type;
            const receiptSection = data.value.settings.find(s => s.section_groups?.some(sg => sg.group_name === 'application_receipt'));
            if (receiptSection) {
                const receiptGroup = receiptSection.section_groups.find(sg => sg.group_name === 'application_receipt');
                if (receiptGroup) receiptGroup.is_switch = true;
            }
        } else {
            get_data.application_title = data.value.settings[0].section_groups[0].group_setting[0].input_value;
        }

        if (data.value.application_template_id) {
            porgram_for_who.value  = data.value.application_template_id;
            application_status.value = data.value.application_status;
        }

        if (call_api_btn.publish === true) {
            call_api_btn.is_change = false;
            call_api_btn.publish   = false;
        }

        data_old.value  = JSON.parse(JSON.stringify(data.value));
        is_loading.value = false;
    } catch (e) {
        console.log(e);
    }
}

const getTemplate = async () => {
    try {
        const res = await proxy.$ajax('ambassador/get-application-template-list', { method: 'get' });
        store.state.program_data.form_ForCreatorList = [];
        res.data.data.forEach(e => {
            e.text = e.ambassador_application_template_name;
            e.type = 'application_template';
            store.state.program_data.form_ForCreatorList.push(e);
        });
    } catch (e) {}
}

// ─── saving ───────────────────────────────────────────────────────
const updateRight = (set) => {
    data.value.settings = set.data;
    if (set.refrash_key) {
        get_data.application_title = set.data[0].section_groups[0].group_setting[0].input_value;
        data.value.basic[0].question[0].client_view.val = set.data[0].section_groups[0].group_setting[0].input_value;
        key_refrash_left.value += 1;
    }
    if (set.rej_open !== null) {
        const index = getIndex(data.value.basic, 'country_location', 'country_location');
        data.value.basic[index.i].is_required = set.rej_open ? true : data.value.basic[index.i].is_required;
        data.value.basic[index.i].is_switch   = set.rej_open ? true : data.value.basic[index.i].is_switch;
        key_refrash_left_country.value += 1;
    }
    console.log('updateRight-->', set.data);
}

const updateLeft = (val) => {
    const value = val.val;
    if (val.field === 'title') {
        const index = getIndex(value, 'title', 'application_title');
        get_data.application_title = value[index.i].question[index.ii].client_view.val;
        data.value.settings[0].section_groups[0].group_setting[0].input_value = value[index.i].question[index.ii].client_view.val;
    }
    if (val.ambassador_application_template_id) {
        porgram_for_who.value = val.ambassador_application_template_id;
        getData();
    }
    if (val.field === 'title' || val.field === 'creator') {
        data.value.basic = val.val;
        checkBasic(data.value.basic, data.value.settings);
        key_refrash_right.value += 1;
    } else {
        data.value[val.field] = JSON.parse(JSON.stringify(val.val));
        if (val.field === 'social_account') {
            checkSocial(data.value.social_account, data.value.settings);
            key_refrash_right.value += 1;
        }
    }
}

const accountTypeUpdated=(val) => {
    console.log('accountTypeUpdated-->', val);
    data.value.application_type = val;
    key_refrash_left.value += 1;
}

const saveCallInside = () => {
    is_all_loading.value        = true;
    store.state.is_loading      = true;
    is_save_call_in.value       = true;
    formLeft.value.submit();
}

const checkResponseSetting = () => {
    let isV = false;
    const mes = [];
    data.value.settings.forEach(setting => {
        if (setting.section_name === 'general_settings') {
            setting.section_groups.forEach(sectionGroup => {
                if (sectionGroup.group_name === 'application_period_start_date') {
                    sectionGroup.group_setting.forEach(set => {
                        if ((set.label === 'application_start_date' || set.label === 'application_deadline') &&
                            set.client_view.show && (!set.client_view.val || set.client_view.val === 'Invalid date')) {
                            isV = true;
                            mes.push('Settings > Automations > Application period (UTC)');
                        }
                    });
                }
            });
        }
        if (setting.section_name === 'response_setting') {
            setting.section_groups.forEach(sectionGroup => {
                if (sectionGroup.is_switch) {
                    sectionGroup.group_setting.forEach(groupSetting => {
                        if (groupSetting.client_view && groupSetting.client_view.name === 'Send Mode') {
                            if (!groupSetting.client_view || groupSetting.client_view.val === 'scheduled') {
                                const value = sectionGroup.group_setting[sectionGroup.group_setting.length - 1].client_view.val;
                                if (!value || value === 'Invalid date') {
                                    sectionGroup.group_setting[sectionGroup.group_setting.length - 1].client_view.err = true;
                                    isV = true;
                                    mes.push(`Settings > Automations > ${sectionGroup.name}`);
                                } else {
                                    sectionGroup.group_setting[sectionGroup.group_setting.length - 1].client_view.err = false;
                                }
                            }
                        }
                    });
                }
            });
        }
        if (setting.section_name === 'auto_rejection') {
            setting.section_groups.forEach(sectionGroup => {
                if (sectionGroup.group_name === 'auto_rejection_age') {
                    const age_val = sectionGroup.group_setting[0].client_view.val;
                    if (sectionGroup.is_switch && (!age_val || (Array.isArray(age_val) && age_val.length === 0)) && store.state.projectName !== 'sephora') {
                        isV = true;
                        mes.push('Settings > Automations > Age');
                        sectionGroup.error_msg = 'Required';
                        sectionGroup.group_setting[0].client_view.err = true;
                    }
                }
                if (sectionGroup.group_name === 'auto_rejection_location') {
                    const loc_val = sectionGroup.group_setting[0].client_view.val;
                    if (sectionGroup.is_switch && (!loc_val || (Array.isArray(loc_val) && loc_val.length === 0))) {
                        isV = true;
                        mes.push('Settings > Automations > Location');
                        sectionGroup.error_msg = 'Required';
                        sectionGroup.group_setting[0].client_view.err = true;
                    }
                }
                if (sectionGroup.group_name === 'auto_rejection_social_follower_count' && sectionGroup.is_switch) {
                    sectionGroup.group_setting.forEach((set, index) => {
                        if (set.client_view) {
                            if (index === 0) {
                                const tkS = data.value.social_account[1];
                                if (tkS.can_edit && tkS.question[0].show && !set.client_view.val && set.label === 'auto_rejection_social_follower_count_tiktok_min') {
                                    isV = true;
                                    mes.push('Settings > Automations > TikTok follower count');
                                    set.client_view.error_msg = 'Required';
                                    set.client_view.err = true;
                                }
                            }
                            if (index === 1) {
                                const igS = data.value.social_account[2];
                                if (igS.can_edit && igS.question[0].show && !set.client_view.val && set.label === 'auto_rejection_social_follower_count_instagram_min') {
                                    isV = true;
                                    mes.push('Settings > Automations > Instagram follower count');
                                    set.client_view.error_msg = 'Required';
                                    set.client_view.err = true;
                                }
                            }
                        }
                    });
                }
            });
        }
    });

    if(is_time_err.value){
        isV = true;
        mes.push('Settings > Automations > Approval Automation');
    }

    return { val: isV, mes };
}

const saveAllSetting = (value) => {
    is_all_loading.value   = true;
    store.state.is_loading = true;
    const setting_had_err  = checkResponseSetting();
    is_show_alert_modal.value = false;

    const temp_status        = handleClickPublish();
    const app_status         = temp_status ? temp_status : type.value === 'create' ? 'draft' : temp_status;
    const is_republish       = application_status.value === 'closed' && is_click_publish.value;
    const tmep_app_status    = data.value.settings[0].section_groups[1].group_setting[2].client_view.show;

    if ((!setting_had_err.val && !value.hadErr) || (app_status === 'draft' && !is_click_publish.value)) {
        store.state.is_loading = true;

        const handleToBack = (field) => {
            return value.data[field].filter(e => e.can_edit).map(e => ({
                ...e,
                show: e.is_switch,
                question: e.question.map((ee, k) => {
                    let input_value = ee.client_view && ee.client_view.val ? ee.client_view.val : ee.val || '';
                    if (ee.label === 'parent_guardian_introduction' && ee.is_switch) {
                        input_value = input_value || ee.client_view.plac;
                    }
                    return {
                        is_question_required: k === 0 ? e.is_required : ee.client_view && ee.client_view.is_required !== undefined ? ee.client_view.is_required : e.is_required,
                        label: ee.label,
                        label_type: ee.label_type,
                        input_value,
                        show: ee.client_view && ee.client_view.show !== undefined ? ee.client_view.show : ee.show !== undefined ? ee.show : e.is_switch,
                    };
                }),
            }));
        };

        const handleToBackSetting = () => {
            return data.value.settings.filter(e => !e.not_use).map(e => ({
                ...e,
                section_groups: e.section_groups.filter(ee => !ee.not_use).map(ee => {
                    return ({
                    
                    ...ee,
                    group_setting: ee.group_setting.map(item => {
                        let input_value = '';
                        if (item.input_type === 'multi_select') {
                            if (item.client_view && item.client_view.val) {
                                input_value = [];
                                item.client_view.val.forEach(v => input_value.push(v.text));
                            } else if (item.input_value) {
                                input_value = item.input_value;
                            }
                        } else {
                            if (item.input_value && item.tag === 'only_input_value') {
                                input_value = item.input_value;
                            } else if (item.client_view && item.client_view.val) {
                                input_value = item.client_view.val;
                            }
                        }
                        if (item.is_need_default || (item.is_email && ee.is_switch)) {
                            input_value = input_value || item.client_view.plac;
                        }
                        return {
                            label: item.label,
                            label_type: item.label_type,
                            show: (item.client_view && item.client_view.show === false) || ee.is_switch === false ? false : true,
                            input_value,
                        };
                    }),
                    show: ee.is_switch === false ? ee.is_switch : true,
                });
                }),
            }));
        };

        if (is_click_publish.value && (application_status.value === 'draft' || application_status.value === 'closed')) {
            data.value.settings[0].section_groups[1].group_setting[2].client_view.show = true;
        }

        const agreObj = handleToBack('agreements_disclaimers');
        agreObj.forEach((e, k) => {
            if (k === 0) e.question = e.question.filter(item => item.label !== 'anchor_term' && item.label !== 'sephora_term');
        });

        const for_bake_data = {
            application_tag:       data.value.settings[0].section_groups[0].group_setting[2].input_value,
            application_status:    app_status,
            application_logo_url:  data.value.preview_logo_image_url,
            basic:                 handleToBack('basic'),
            social_account:        handleToBack('social_account'),
            parent_guardian_consent: handleToBack('parent_guardian_consent'),
            agreements_disclaimers: agreObj,
            custom_question: value.data.custom_question.map(e => ({
                ...e.client_view,
                input_option: e.client_view.input_option.map(ee => ee.name),
                input_type_id: e.id,
                custom_question_id: e.is_new ? -1 : e.cus_id,
            })),
            settings: handleToBackSetting(),
            application_type: data.value.application_type,
        };

        if (type.value === 'edit') {
            for_bake_data.application_id = porgram_id.value;
        } else {
            for_bake_data.application_template_id = porgram_for_who.value;
        }
        console.log('for_bake_data-->', for_bake_data);
        const api = type.value === 'create' ? '/ambassador/create-application' : '/ambassador/update-application';
        proxy.$ajax(api, { method: 'post', data: for_bake_data })
            .then(async res => {
                is_copy.value        = false;
                is_first_create.value = false;
                get_form_data_api.value = 'ambassador/get-application-data';
                porgram_id.value     = res.data.data.ambassador_application_id;
                const pendingMap = localStorage.getItem('is_new_map_pending');
                if (pendingMap) {
                    const map = JSON.parse(pendingMap);
                    await Promise.all(
                        Object.keys(map).filter(field => !map[field]).map(field =>
                            proxy.$ajax('/ambassador/section-seen', {
                                method: 'post',
                                data: { ambassador_application_id: porgram_id.value, section_key: field },
                            })
                        )
                    );
                    localStorage.removeItem('is_new_map_pending');
                }
                handleIfPublish(is_republish, tmep_app_status, res);
            })
            .catch(err => {
                HandleErrFunction(err, { $notify: proxy.$notify, $store: store });
                console.log(err);
                is_click_publish.value  = false;
                store.state.is_loading  = false;
                is_all_loading.value    = false;
            });
    } else {
        is_click_publish.value = false;
        err_box.value = [];
        if (value.err_mes.length > 0) err_box.value = value.err_mes;
        if (setting_had_err.val) err_box.value = [...err_box.value, ...setting_had_err.mes];
        is_show_unp_modal.value = true;
        store.state.is_loading  = false;
        is_all_loading.value    = false;
    }
}

const handleIfPublish = (is_republish, tmep_app_status, res) => {
    const promises = [];
    let oneAlert = false;
    call_api_btn.is_change = true;

    if (is_click_publish.value && !is_republish) {
        promises.push(
            proxy.$ajax('/ambassador/publish-application', { method: 'post', data: { application_id: porgram_id.value } })
                .then(() => {
                    notAlert(application_status.value !== 'draft' ? ' Application updated.' : ' Application created.');
                    oneAlert = true;
                    call_api_btn.publish = true;
                })
                .catch(() => {
                    if (tmep_app_status !== undefined) {
                        data.value.settings[0].section_groups[1].group_setting[2].client_view.show = tmep_app_status;
                    }
                    call_api_btn.publish = false;
                })
        );
    } else {
        call_api_btn.publish = false;
    }

    if (is_republish) {
        data.value.settings[0].section_groups[1].group_setting[2].client_view.show = true;
    }

    if (!data.value.settings[0].section_groups[1].group_setting[2].client_view.show &&
        (application_status.value === 'active' || application_status.value === 'scheduled')) {
        promises.push(
            proxy.$ajax('/ambassador/close-application', { method: 'post', data: { application_id: porgram_id.value } })
        );
    } else if (is_republish && application_status.value === 'closed') {
        promises.push(
            proxy.$ajax('/ambassador/republish-application', { method: 'post', data: { application_id: porgram_id.value } })
                .catch(() => {
                    data.value.settings[0].section_groups[1].group_setting[2].client_view.show = tmep_app_status;
                })
        );
    }

    Promise.all(promises)
        .then(() => {
            if (type.value === 'create') {
                is_show_alert_modal.value = false;
                is_saving.value = true;
                is_leave.value  = true;
                if (is_click_publish.value) window.localStorage.setItem('ANCHOR_show_pub_modal', true);
                window.location.href = `/programs/application/edit/${res.data.data.ambassador_application_id}`;
                return;
            }
            if (application_status.value === 'draft' && is_click_publish.value) {
                pub_modal.value.open();
            }
            if (is_click_window.value) {
                openClose();
                is_click_window.value = false;
                return;
            }
            is_click_publish.value = false;
            getData();
            store.state.is_loading = false;
            is_all_loading.value   = false;
        })
        .catch(err => {
            console.log(err);
            HandleErrFunction(err, { $notify: proxy.$notify, $store: store });
            store.state.is_loading = false;
            is_all_loading.value   = false;
        });

    if (!is_click_publish.value) {
        if (!oneAlert) notAlert(' Application saved.');
        if (!will_close_setting.value && promises.length === 0) getData();
    }
    if (will_close_setting.value) openClose();
}

const notAlert = (val) => {
    proxy.$notify({
        group: 'white',
        text: `<svg><use xlink:href="#yes--sprite"></use></svg> ${val}`,
        type: 'success',
    });
}

// ─── button actions ───────────────────────────────────────────────
const onlyClose = () => {
    if (is_can_save.value) {
        is_show_alert_modal.value = true;
    } else {
        store.state.is_loading = true;
        openClose();
    }
}

const publish = () => {
    const setting_had_err = checkResponseSetting();
    if (setting_had_err.val) {
        err_box.value = [...setting_had_err.mes];
        is_show_unp_modal.value = true;
        return;
    }
    publish_checklist.value = [false, false, false, false, false];
    is_show_publish_modal.value = true;
};

const doPublish = () => {
    is_click_publish.value = true;
    store.state.is_loading = true;
    saveCallInside();
};

const handleClickPublish = () => {
    return is_click_publish.value
        ? 'active'
        : application_status.value || 'draft';
}

const onlyView = () => {
    is_only_for_view.value = true;
}

const closeOnlyForView = () => {
    is_only_for_view.value = false;
    if (from_list_handle_for_view.value) openClose();
}

const checkUrl = (url, list) => {
    let suffix = 1;
    while (list.some(item => item.url.split('/p/')[1] === url)) {
        url = `${url}-${suffix}`;
        suffix++;
    }
    return url;
}

const delPro = () => {
    if (type.value === 'create') {
        openClose();
        is_show_del_modal.value = false;
        notAlert(' Application deleted.');
    } else {
        store.state.is_loading = true;
        proxy.$ajax('/ambassador/delete-application', { method: 'post', data: { application_id: porgram_id.value } })
            .then(() => {
                notAlert(' Application deleted.');
                is_saving.value = true;
                window.location.href = '/programs/applications-list';
                store.state.is_loading = false;
            })
            .catch(err => {
                HandleErrFunction(err, { $notify: proxy.$notify, $store: store });
                store.state.is_loading = false;
            });
    }
}

const openClose = () => {
    store.state.is_loading              = true;
    store.state.program_data.type       = '';
    store.state.program_data.create_data = null;
    store.state.program_data.id         = 1;
    store.state.program_data.is_preview = false;
    is_saving.value = true;
    is_leave.value  = true;
    if (is_key_ref.value) {
        console.log(is_leave.value);
        router.go(0);
    } else {
        if (document.referrer && document.referrer.includes('programs/application/create')) {
            window.location.href = '/programs/applications-list';
        } else {
            window.history.go(-1);
        }
    }
}

const handleGoLive = () => {
    if (window.localStorage.getItem('ANCHOR_show_pub_modal')) {
        pub_modal.value.open();
        window.localStorage.removeItem('ANCHOR_show_pub_modal');
    }
}

const handleBeforeUnload = (event) => {
    try {
        if (!is_leave.value && is_can_save.value) {
            event.preventDefault();
            event.returnValue = '';
            return '';
        }
    } catch (error) {
        console.error('Error in handleBeforeUnload:', error);
    }
}

// ─── navigation guard ─────────────────────────────────────────────
onBeforeRouteLeave((to, from, next) => {
    if (is_can_save.value) {
        if (!is_show_alert_modal.value && !is_saving.value) {
            is_click_window.value     = true;
            next(false);
            is_show_alert_modal.value = true;
        } else {
            is_leave.value            = true;
            next();
            is_show_alert_modal.value = false;
        }
    } else {
        is_leave.value = true;
        next();
        if (route.params && type.value === 'create') {
            window.location.href = '/programs/applications-list';
        }
    }
});

// ─── lifecycle ────────────────────────────────────────────────────
onMounted(async () => {
    if (!permission_recruitment.value.manageApplications.permission ||
        !permission_recruitment.value.editApplicationSettings.permission) {
        router.push({ name: 'creator--list' });
        return;
    }

    const item = store.state.program_data;
    const rou  = route.params;
    originalURL.value = route.fullPath;

    const parts  = route.path.split('/');
    type.value   = parts[3]; // ex "/programs/application/create/1"
    is_all_loading.value = true;

    if (item.create_data) Object.assign(get_data, item.create_data);

    if (type.value === 'create') {
        get_form_data_api.value = 'ambassador/get-application-template';
        is_first_create.value   = true;
        porgram_id.value        = null;
        if (!get_data.application_title) {
            const da = JSON.parse(window.localStorage.getItem('ANCHOR_program_create_data'));
            if (!da) { openClose(); } else { Object.assign(get_data, da); }
        }
    } else if (type.value === 'edit') {
        get_form_data_api.value = 'ambassador/get-application-data';
        porgram_id.value        = rou.application_id;
    }

    await getTemplate();
    await getData();
    handleGoLive();

    is_all_loading.value   = false;
    store.state.is_loading = false;

    if (item.is_preview) {
        onlyView();
        from_list_handle_for_view.value = true;
    }
});

// created
window.addEventListener('beforeunload', handleBeforeUnload);
// preventRefresh 由 mixin 提供，保留事件綁定
window.addEventListener('keydown', proxy.preventRefresh ?? (() => {}));

onBeforeUnmount(() => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
    window.removeEventListener('keydown', proxy.preventRefresh ?? (() => {}));
});
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.pro-setting {
    width: 100vw;
    height: 100vh;
    position: fixed;
    background-color: var(--dark-blue);
    top: 0;
    left: 0;
    z-index: 4;

    .head {
        height: 48px;
        width: 100%;
        @include flexCenter();
        padding: 0 16px;

        .left {
            flex: 1;
            font: var(--font-med-14);
            color: var(--white);
            @include flexCenter();

            .svg-icon {
                width: 16px;
                height: 16px;
                margin-right: 8px;
                fill: var(--white);
                cursor: pointer;
            }
        }

        .right {
            @include flexCenter();
            gap:12px;

            .desc {
                font-size: 12px;
                color: var(--black-40);
            }

            .ui-button {
                &.unp-btn{
                    background-color: var(--black-10);
                    color: var(--black-40);
                }
            }

            .settings-btn {
                border: solid 1px var(--white);
                background-color: transparent;
                color: var(--white);
                &:hover {
                    background-color: var(--white);
                    color: var(--dark-blue);
                }
            }

            .el-button + .el-button {
                margin: 0;
            }

            .pre-btn {
                color: var(--white);

                &:hover {
                    border: solid 1px var(--white);
                    background-color: transparent;
                }
            }

            .del-btn {
                border: solid 1px var(--red);
                background-color:var(--white);
                color:var(--red);
            }

        }
    }

    .ui-dropdown--inner{
        .ui-button{
            width: 100%;
            justify-content: flex-start;
            span{
                width: 100%;
            }
        }
    }


}

.pro-setting-box {
    background-color: var(--dark-blue);
    display: grid;
    grid-template-columns: 1fr;
    top: 0;

    &.pro-setting-box--with-panel {
        grid-template-columns: 1fr 320px;
    }

    .left-template {
        width: 100%;
    }

    .right-template {
        width: 320px;
        position: relative;
        padding: 0;
        background: #fff;
        box-shadow: var(--left-2dp);
    }

    // Slide from right transition
    .slide-right-enter-active,
    .slide-right-leave-active {
        transition: transform 0.25s ease, opacity 0.25s ease;
    }

    .slide-right-enter-from,
    .slide-right-leave-to {
        transform: translateX(100%);
        opacity: 0;
    }

    .slide-right-enter-to,
    .slide-right-leave-from {
        transform: translateX(0);
        opacity: 1;
    }

    input,
    textarea {
        padding: 6px 8px;
        height: 36px;
        border: 1px solid var(--black-20);
        background-color: white;
        flex: 1;
        border-radius: 6px;
        color: var(--black-90);
        transition: .15s border-color ease;
        font-weight: 500;
        font-family: var(--font);

        &:hover {
            border-color: var(--black-50);
        }

        &:focus {
            outline: none;
            border-color: var(--dark-blue);
        }

        &::placeholder {
            color: var(--black-50);
            font-weight: 500;
            line-height: 18px;
        }
    }

    textarea {
        height: 120px;
    }
}

.modal-del-btn{
    background-color:var(--red) !important;
}

.alert-modal {
    .el-dialog__body {
        padding: 0;
    }
}

.un-pub-modal{
    .el-dialog__body {
        padding: 0;
    }

    .box {
        padding: 24px;
        header {
            font: var(--font-demi-20);
            color: var(--black-90);
            letter-spacing: 1px;
            margin-bottom: 8px;
        }

        p {
            font-size: 16px;
            color: var(--black-60);
        }

        .btns {
            @include flexCenter();
            justify-content: flex-end;
        }
    }

    ul li{
        list-style: disc !important;
        margin-left:24px;
    }

}

.publish-checklist-modal {
    .el-dialog__body {
        padding: 0;
    }

    .box {
        padding: 24px;

        header {
            font: var(--font-demi-24);
            color: var(--black-90);
            margin-bottom: 8px;
        }

        .sub {
            font:var(--font-med-16);
            color: var(--Text-primary);

            .link {
                color: var(--blue);
                cursor: pointer;
            }
        }

        .checklist {
            display: flex;
            flex-direction: column;
            gap: 0;
            margin-bottom: 24px;

            .checklist-item {
                display: flex;
                align-items: flex-start;
                gap: 12px;
                padding: 14px 0;
                border-bottom: 1px solid var(--black-10);
                cursor: pointer;

                input[type='checkbox'] {
                    margin-top: 2px;
                    width: 16px;
                    height: 16px;
                    flex-shrink: 0;
                    cursor: pointer;
                }

                .checklist-text {
                    display: flex;
                    flex-direction: column;
                    gap: 3px;
                }

                .checklist-title {
                    font: var(--font-med-16);
                    color: var(--black-90);

                    .red { color: var(--red); margin-left: 2px; }
                }

                .checklist-desc {
                    font-size: 14px;;
                    color: var(--black-60);
                    line-height: 1.4;
                }
            }
        }

        .btns {
            @include flexCenter();
            justify-content: flex-end;
            gap: 12px;
        }
    }
}


</style>